module.exports = __webpack_public_path__ + "static/media/magnataur.7639c5e3.png";